/**
 * Directory at /directory.
 *
 * The whole company: corporate nested by reporting line, then one section per
 * store with its phone, extensions and mailbox. For a store this is mainly how
 * you reach another store or find who at the Store Support Center owns a thing.
 *
 * The rendering lives in EmployeeDirectory in `@ampersandbrands/ui`, because
 * Cockpit shows the identical page. This file is only the fetch plus the Sweet
 * Spot page chrome.
 *
 * There is no separate org chart page. The directory is already ordered as one.
 */

import { EmployeeDirectory, StateCard } from '@ampersandbrands/ui';
import { useDirectory } from '@/lib/useDirectory';

export function Directory() {
  const { data, isLoading, error } = useDirectory();

  return (
    <div className="mx-auto w-full max-w-lg pb-24">
      <div className="mb-5">
        <h1 className="text-2xl font-semibold text-candy-ink dark:text-candy-dark-ink">Directory</h1>
        <p className="text-sm text-candy-ink-muted dark:text-candy-dark-ink-muted">
          Everyone in the company, and how to reach every store
        </p>
      </div>

      <EmployeeDirectory
        people={data?.people ?? []}
        stores={data?.stores ?? []}
        corporatePhone={data?.corporate_phone ?? null}
        syncedAt={data?.synced_at ?? null}
        loading={isLoading}
        error={
          error ? (
            <StateCard
              title="The directory could not load"
              description="Pull down to try again, or let IT know if it keeps happening."
              tone="error"
            />
          ) : null
        }
      />
    </div>
  );
}
